(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ChangeObjectController', ChangeObjectController);

    ChangeObjectController.$inject = ['$state', '$uibModalInstance', 'LicenceCode', 'AlertService', 'entity'];

    function ChangeObjectController($state, $uibModalInstance, LicenceCode, AlertService, entity) {
        var vm = this;

        vm.licence = entity;
        vm.objectUniqueCode = "";

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {

            var body = {
                licence: vm.licence.licenceCode,
                objectUniqueCode: vm.objectUniqueCode,
            };

            LicenceCode.update(body, onSuccess, onError);

            function onSuccess(){
                $uibModalInstance.close();
                AlertService.success("Update licence");
            }

            function onError(error){
                AlertService.error("Licence cannot be update");
            }

        };

    }
})();
